interface StatsStripProps {
	totalTitles: number;
	totalGenres: number;
}

/** Ba ô số liệu — lấy từ pagination.totalItems và /the-loai, không hardcode. */
export function StatsStrip({ totalTitles, totalGenres }: StatsStripProps) {
	const stats = [
		{
			value: totalTitles ? `${totalTitles.toLocaleString('vi-VN')}+` : '—',
			label: 'Tựa hoạt hình trong kho',
		},
		{
			value: totalGenres ? String(totalGenres) : '—',
			label: 'Thể loại để khám phá',
		},
		{ value: '24/7', label: 'Cập nhật tập mới mỗi ngày' },
	];

	return (
		<div className="mt-10 grid grid-cols-3 gap-2 min-[700px]:gap-3.5">
			{stats.map((stat) => (
				<div
					key={stat.label}
					className="rounded-panel border border-line bg-linear-to-br from-[#14172b] to-[#101221] px-2.5 py-3.5 min-[700px]:px-4.5 min-[700px]:py-4"
				>
					<strong className="block text-lg leading-tight text-white min-[700px]:text-[23px]">
						{stat.value}
					</strong>
					<span className="text-xs text-muted">{stat.label}</span>
				</div>
			))}
		</div>
	);
}
